const { plans } = require("./software-plans");
const limits = {
  email: 254,
  name: 100,
  website: 500,
  message: 2000,
};
function validateSoftwareRequest(form) {
  for (const [key, limit] of Object.entries(limits)) {
    if (
      typeof form[key] !== "string" ||
      form[key].length > limit ||
      /\x00/.test(form[key]) ||
      (key !== "message" && /[\r\n]/.test(form[key]))
    )
      return "Please check the length and format of your project details.";
  }
  if (!/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(form.email))
    return "Enter a valid email address.";
  if (!["name", "message"].every((key) => form[key].trim()))
    return "Complete the required project details.";
  if (!plans.some((plan) => plan.name === form.plan))
    return "Choose a software plan.";
  return "";
}
async function submitSoftwareRequest(payload, endpoint, fetcher = fetch) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetcher(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal,
      credentials: "omit",
    });
    const data = await response.json().catch(() => ({}));
    if (response.ok && data.accepted === true && data.product === "software")
      return {
        accepted: true,
        message:
          "Your software request was accepted by the mail server for delivery to ARI. ARI will contact you to discuss the requirements, scope, pricing and setup. No payment was taken and access has not been activated.",
      };
    const messages = {
      400: "Please check your name, email and required scope.",
      403: "This preview cannot submit requests. You can send your brief using the email link below.",
      409: "This request reference has an uncertain result. Please contact ARI before sending another request.",
      429: "Too many requests. Please wait an hour before trying again.",
      503: "The email service is not configured for this preview. Your request has not been sent. Use Request software by email below.",
    };
    return {
      accepted: false,
      message:
        messages[response.status] ||
        "We could not confirm delivery. Please contact ARI before sending another request.",
    };
  } finally {
    clearTimeout(timer);
  }
}
function softwareMailto(form) {
  const plan = plans.find((p) => p.name === form.plan);
  const body = `ODIN tailored implementation enquiry\nSelected starting point: ${
    form.plan
  }\nStarting price: ${plan ? plan.price : ""}\n\nName: ${form.name}\nEmail: ${
    form.email
  }\nWebsite: ${form.website || "Not supplied"}\n\nRequired scope:\n${
    form.message
  }\n\nPlease contact me to discuss scope, pricing, payment terms, installation location, access method and schedule before implementation. This enquiry is not a payment or activated account. Robot hardware is separate.\nSource: https://www.ari.company/odin`;
  return `mailto:manager@ari.company?subject=${encodeURIComponent(
    "ODIN software — " + form.plan + " request"
  )}&body=${encodeURIComponent(body)}`;
}
module.exports = {
  validateSoftwareRequest,
  submitSoftwareRequest,
  softwareMailto,
};
